import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ApiToken } from "./types";

export const getApiTokensRequest = (userId: string) =>
  apiProxyRequest<ApiToken[]>(`/users/${userId}/api-tokens`);
